import React, { useEffect, useState, useContext } from 'react';
import { validarME } from '../api/apiMe';
import { MeuContexto } from "../App";
import CompActive from '../components/CompActive.jsx';
import { FaClock, FaCalendarAlt, FaInfoCircle } from 'react-icons/fa';

// Group events by day of the week
const groupEventsByDay = (events) => {
    return events.reduce((acc, event) => {
        (acc[event.diaSemana] = acc[event.diaSemana] || []).push(event);
        return acc;
    }, {});
};

function PgAgenda() {
    const [isloading, setIsLoading] = useState(true);
    const { setlogado, setusername, setuser } = useContext(MeuContexto)

    // Hardcoded data as in the original component
    const agendas = [
        { id: 1, title: "Noite do Rock", foto: `${import.meta.env.VITE_FOTO || ''}casamentom.jpg`, diaSemana: 'Terça-feira', horario: '19:30 - 22:00' },
        { id: 2, title: "Favoritos Indie", foto: `${import.meta.env.VITE_FOTO || ''}favoritam.jpg`, diaSemana: 'Sexta-feira', horario: '19:30 - 22:00' },
        { id: 3, title: "Domingo Acústico", foto: `${import.meta.env.VITE_FOTO || ''}detonaltasm.jpg`, diaSemana: 'Domingo', horario: '18:00 - 21:00' },
    ];
    
    const groupedAgendas = groupEventsByDay(agendas);
    const orderedDays = ['Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'];


    useEffect(() => {
        _carregatela();
    }, []);

    async function _carregatela() {
        const me = await validarME.me();
        if (me) {
            setuser(me);
            setusername(me.username);
            setlogado(true);
        } else {
            setuser([]);
            setlogado(false);
        }
        setIsLoading(false);
    }

    if (isloading) {
        return (
            <main className="min-h-screen bg-background flex items-center justify-center">
                <CompActive size="lg" text="Carregando agenda..." />
            </main>
        );
    }

    return (
        <main className="min-h-screen bg-background text-text antialiased selection:bg-primary/30">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
                {/* Header */}
                <header className="text-center mb-16 animate-fade-in">
                    <h1 className="text-4xl md:text-6xl font-display font-bold text-text mb-4">
                        Programação Semanal
                    </h1>
                    <p className="text-xl text-text-subtle max-w-3xl mx-auto">
                        Confira os horários dos nossos shows semanais e não perca nenhuma apresentação.
                    </p>
                </header>

                {/* Agenda List */}
                <div className="space-y-12">
                    {orderedDays.map((day, index) => {
                        const events = groupedAgendas[day];
                        if (!events) return null;

                        return (
                            <section 
                                key={day} 
                                className="animate-fade-in-up" 
                                style={{animationDelay: `${index * 100}ms`}}
                            >
                                <h2 className="text-3xl font-display font-bold text-primary mb-6 border-b-2 border-border pb-3">
                                    {day}
                                </h2>
                                <div className="space-y-8">
                                    {events.map((agenda) => (
                                        <div key={agenda.id} className="group grid grid-cols-1 md:grid-cols-4 gap-6 items-center">
                                            {/* Image */}
                                            <div className="md:col-span-1 h-48 rounded-xl overflow-hidden">
                                                 <img
                                                    src={agenda.foto}
                                                    alt={`Apresentação de ${agenda.title}`}
                                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                                />
                                            </div>
                                            {/* Details */}
                                            <div className="md:col-span-2">
                                                <h3 className="text-2xl font-bold font-display text-text mb-2">{agenda.title}</h3>
                                                <div className="flex items-center gap-3 text-text-subtle">
                                                    <FaClock />
                                                    <p className="text-lg font-medium">{agenda.horario}</p>
                                                </div>
                                            </div>
                                            {/* Status */}
                                            <div className="md:col-span-1 md:text-right">
                                                 <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold bg-surface border border-border">
                                                    Programação Regular
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>
                        );
                    })}
                </div>

                {/* Additional Info Section */}
                <div className="mt-20">
                    <div className="bg-surface border border-border rounded-2xl p-8 flex items-start gap-6">
                        <FaInfoCircle className="text-primary text-3xl mt-1 flex-shrink-0" />
                        <div>
                             <h3 className="text-xl font-bold font-display text-text mb-2">
                                Informações Importantes
                            </h3>
                            <p className="text-text-subtle">
                                Os horários dos shows são fixos, mas podem sofrer alterações em datas especiais ou feriados. Cada apresentação tem duração média de 2h30.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default PgAgenda;